import { truncateText } from '.';
const max_chars = process.env.VUE_APP_MAX_ENTITY_CHARACTERS || 30;
// Formats json in format of PrimeVue TreeSelect
export const formatTreeData = (data, maxChars) => {
    const maxCharacters = maxChars ?? max_chars;
    let resData = [];
    for (let item of data) {
        let nodeData = {
            key: item.id,
            label: truncateText(item.name, maxCharacters),
            children: item.children.length > 0 ? formatTreeData(item.children) : [],
        };
        resData.push(nodeData);
    }
    return resData;
};

export const formatTreeDatatable = (data) => {
    let resData = [];
    for (let item of data) {
        let nodeData = {
            key: item.id,
            data: {
                id: item.id,
                name: truncateText(item.name, max_chars),
                childCount: item.children.length,
                parent_id: item.parent_id,
                department_id: item?.department_id,
                users_count: item?.users_count,
                managers: item?.managers || [],
            },
            children: item.children.length > 0 ? formatTreeDatatable(item.children) : [],
        };
        resData.push(nodeData);
    }
    return resData;
};

export const formatVueTreeSelectData = (data) => {
    const removeEmptyChildren = (data) => {
        let resData = [];
        for (let item of data) {
            let nodeData = {
                id: item.id,
                label: item.name,
            };
            if (item.children && item.children.length > 0) {
                nodeData.children = removeEmptyChildren(item.children);
            }
            if (nodeData.children && nodeData.children.length === 0) {
                delete nodeData.children;
            }
            resData.push(nodeData);
        }
        return resData;
    };

    return removeEmptyChildren(data);
};

export const formatChildParentBreadCrumb = (data, maxLen) => {
    const maxLength = maxLen ?? 15; // Define the maximum length you want
    if (data.name.length > maxLength) {
        data.name = data.name.slice(0, maxLength) + '...'; // Trim the string to the desired length
    }
    if (data.parent) {
        return [...formatChildParentBreadCrumb(data.parent, maxLen), { label: data.name }];
    }
    return [{ label: data.name }];
};

export const flattenArray = (arr) => {
    const tempArr = [...arr];
    const result = [];

    const deepCopy = (obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj; // Return non-object types as is
        }

        if (Array.isArray(obj)) {
            return obj.map(deepCopy); // Recursively deep copy array elements
        }

        const copy = {};
        Object.keys(obj).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                copy[key] = deepCopy(obj[key]); // Recursively deep copy object properties
            }
        });

        return copy;
    };

    const flatten = (item) => {
        const copy = deepCopy(item);
        result.push(copy);

        if (copy.children && copy.children.length > 0) {
            copy.children.forEach(flatten);
            // Optionally, you can choose not to delete the 'children' property
            // delete copy.children;
        }
    };

    tempArr.forEach(flatten);
    return result;
};

export const formatSingleSeriesBarChartData = (jsonData, dataKey) => {
    const seriesObj = {
        data: [],
        labels: [],
        fillColors: ['#fff'],
    };
    jsonData?.forEach((item) => {
        seriesObj.data.push(item[dataKey]), seriesObj.labels.push(item.name);
    });
    return seriesObj;
};

export const formatMultiSeriesChartData = (jsonData, innerKey, allElements, dataKey) => {
    // Initialize an empty object to hold the transformed data
    let series = [];
    let categories = [];
    // Iterate over the data array
    jsonData.forEach((element) => {
        // push each name to categories for x axis data
        categories.push(element.name);
        // Extract the innerKey elements
        const innerKeyElement = element[innerKey];
        // Iterate over the 'dataKeys' array to extract data from each key
        allElements.forEach((elName) => {
            // Check if series name already exist
            const existingSeriesIndex = series?.findIndex((seriesItem) => seriesItem.name === elName);
            // Now extract the data matching the element
            const dataElement = innerKeyElement.find((el) => el.name === elName);
            // if yes then push into that
            if (existingSeriesIndex !== -1) {
                series[existingSeriesIndex]?.data?.push(dataElement ? dataElement[dataKey] : 0);
            } else {
                // create new series
                let newSeries = {
                    name: elName,
                    data: [],
                };
                // push the item data into the data array
                newSeries.data.push(dataElement ? dataElement[dataKey] : 0);
                // push the new series into the series
                series.push(newSeries);
            }
        });
    });
    return {
        series,
        categories,
    };
};
